import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import brandPortalOrdersbrandOrderTokenOrderFulfilment from "@faire/web-api--source/routes/www/brand-portal/orders/brandOrderToken/order-fulfilment";
import brandPortalPayouts from "@faire/web-api--source/routes/www/brand-portal/payouts";
import React from "react";

import { PayoutNotReceivedIA } from "./instantAnswersComponents/payments/PayoutNotReceivedIA";

export const PayoutNotReceived: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => PAYOUT_NOT_RECEIVED_TITLE(strictLocalize),
    getDescription: () => PAYOUT_NOT_RECEIVED_DESCRIPTION(context),
  };
};

const PAYOUT_NOT_RECEIVED_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Understanding payout delays",
    description: {
      text: "Title for the answer of how to understand payout delays in the self-serve portal",
    },
  });

const getPrimaryCTA: CtaBuilderFn = (context, strictLocalize) => {
  const { brandOrder } = context;
  if (brandOrder && brandOrder.brand_order?.token) {
    return {
      label: strictLocalize({
        defaultMessage: "View your payout",
        description: {
          text: "CTA button to view the payout in the account settings",
        },
      }),
      getLink: () =>
        brandPortalOrdersbrandOrderTokenOrderFulfilment(
          brandOrder.brand_order?.token ?? "",
          { sync: "true" }
        ),
    };
  }
  return {
    label: strictLocalize({
      defaultMessage: "View your payouts",
      description: {
        text: "CTA button to view the payout in the account settings",
      },
    }),
    getLink: () => brandPortalPayouts(),
  };
};

const PAYOUT_NOT_RECEIVED_DESCRIPTION = (_context: InstantAnswerContext) => {
  return <PayoutNotReceivedIA />;
};
